import { ReactNode } from "react";
import { MosaicTrafficLightClass } from "../traffic-lights/MosaicTrafficLightClass";
import { AitRowGroupData } from "./functions/AitRowGroupData";
import {
  AitHeaderGroupData,
  AitLocationBodyRow,
  AitLocationBodyRowGroup,
  AitLocationHeader,
  AitLocationHeaderRow,
  AitTablePosition,
} from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowDeletedItemTrafficLightProps {
  location: AitLocationHeaderRow | AitLocationBodyRow;
}

/**
 * Render a deleted-item traffic light for a row when present.
 *
 * @template T - Row payload type
 * @param props - Component props
 * @param props.location - The row location
 */
export const AitRowDeletedItemTrafficLight = <T,>({
  location,
}: AitRowDeletedItemTrafficLightProps): ReactNode => {
  const { state } = useTableContext<T>();
  const thisRowGroup: AitHeaderGroupData<T> | AitRowGroupData<T> | undefined =
    trGetPositionFromLocation(
      state,
      {
        position:
          location.position === AitTablePosition.headerRow
            ? AitTablePosition.header
            : AitTablePosition.bodyRowGroup,
        tableSection: location.tableSection,
        rowGroup: location.rowGroup,
        rowGroupId: location.rowGroupId,
      } as AitLocationHeader | AitLocationBodyRowGroup,
      true,
    ).data;

  const deletedItemTrafficLight =
    (thisRowGroup?.changedRows?.filter(
      (dr) =>
        dr.coreTrafficLight === "RedError" && dr.idAfterTrafficLightIsShown === location.rowId,
    ).length ?? 0) > 0
      ? "RedError"
      : "BlankNotEvaluated";

  return !state?.noTrafficLights && deletedItemTrafficLight !== "BlankNotEvaluated"
    ? new MosaicTrafficLightClass(deletedItemTrafficLight, "-4px", "-8px").element
    : null;
};

AitRowDeletedItemTrafficLight.displayName = "AitRowDeletedItemTrafficLight";
